var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1131.886,
    height: 135.779,
    viewBox: "0 0 1131.886 135.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1234",
    "data-name": "Grupo 1234",
    transform: "translate(-128.114 -351.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M4-.319V-6.78H-29.305V-.319h13.056V40.648h7.194V-.319ZM42.5,40.648V34.187H19.389V19.932H39.107V13.537H19.389V-.319H42.5V-6.78H12.2V40.648ZM84.6,26.46H77.343c-1.132,4.8-4.4,8.127-9.659,8.127a9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788S58.358,4.677,60.69,2.146A9.477,9.477,0,0,1,67.684-.719c5.262,0,8.46,3.331,9.592,8.127H84.6C82.938-2.051,76.41-7.18,67.684-7.18A17.187,17.187,0,0,0,55.227-2.117c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.187,17.187,0,0,0,12.457,5.063C76.277,41.048,83,35.919,84.6,26.46Zm45.3,14.189V-6.78h-7.194V26.526L100.791-6.78H94.2V40.648h7.194V7.275l21.916,33.373Zm44.764-23.714c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,157.612-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C174.8,31.322,174.665,26.06,174.665,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C167,4.744,167.471,7.408,167.471,16.934Zm47.895,23.714V34.187H192.517V-6.78h-7.194V40.648ZM254.2,16.934c0-9.126.133-14.388-4.53-19.051A17.122,17.122,0,0,0,237.148-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a17.938,17.938,0,0,0,24.98,0C254.334,31.322,254.2,26.06,254.2,16.934Zm-7.194,0c0,9.526-.466,12.19-2.8,14.722a9.971,9.971,0,0,1-14.122,0c-2.331-2.531-2.8-5.2-2.8-14.722s.466-12.19,2.8-14.722a9.971,9.971,0,0,1,14.122,0C246.541,4.744,247.007,7.408,247.007,16.934ZM297.5,22.263V15H280.18v6.128h10.125V23.8a10.715,10.715,0,0,1-2.4,7.461,10.054,10.054,0,0,1-7.727,3.331,9.477,9.477,0,0,1-6.994-2.864c-2.331-2.531-2.864-5.262-2.864-14.788s.533-12.19,2.864-14.722A9.527,9.527,0,0,1,280.18-.719c5.329,0,8.793,3.064,9.992,8.26h7.261C296.1-.585,290.239-7.18,280.18-7.18a16.969,16.969,0,0,0-12.457,5.063c-4.663,4.663-4.6,9.925-4.6,19.051s-.067,14.388,4.6,19.051a18.178,18.178,0,0,0,25.513-.333C296.367,32.322,297.5,28.391,297.5,22.263Zm17.786,18.385V-6.78h-7.194V40.648Zm47.3,0L345.195-6.78h-5.8L322.013,40.648h7.661l3.264-9.526h18.718l3.264,9.526ZM349.658,24.994H335.07l7.394-21.05Z",
    transform: "translate(157.419 401.566)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1237",
    "data-name": "Grupo 1237",
    transform: "translate(518 307.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    d: "M276.665,279.579V244.641H254.529v135.72h22.135V301.714h22.042L311.4,279.579Z",
    transform: "translate(117.787 -200.582)",
    fill: "#b0b0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_133",
    "data-name": "Caminho 133",
    d: "M460.674,279.544a50.156,50.156,0,0,0-28.292,8.679V244.607H410.247v135.72h22.135V330.876a28.874,28.874,0,0,1,27.734-29.19,28.26,28.26,0,0,1,28.79,28.254v50.387h22.135v-49.05c0-27.709-22.653-51.716-50.365-51.732",
    transform: "translate(230.958 -200.607)",
    fill: "#b0b0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M236.808,264.6A50.4,50.4,0,1,0,287.2,315a50.4,50.4,0,0,0-50.4-50.4m3.673,78.424a28.27,28.27,0,1,1,24.355-24.358,28.271,28.271,0,0,1-24.355,24.358",
    transform: "translate(67.949 -185.647)",
    fill: "#b0b0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M196.675,303.934A50.4,50.4,0,1,0,147.5,365.393H172.05l12.69-22.139H147.5a28.264,28.264,0,1,1,26.038-39.32c.192.453.338.93.508,1.383H147.5a9.682,9.682,0,0,0,0,19.364h49.447a50.3,50.3,0,0,0-.27-20.747",
    transform: "translate(2.904 -185.671)",
    fill: "#b0b0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M385.676,303.934A50.4,50.4,0,1,0,336.5,365.393h24.55l12.709-22.138H336.5a28.264,28.264,0,1,1,26.038-39.321c.189.453.338.93.505,1.383H336.5a9.682,9.682,0,1,0,0,19.364h49.447a50.253,50.253,0,0,0-.266-20.747",
    transform: "translate(140.546 -185.671)",
    fill: "#b0b0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M375.375,315a28.285,28.285,0,0,1,28.273-28.27h19.937l12.69-22.129H403.648a50.389,50.389,0,1,0,0,100.778l19.937,0,12.69-22.126H403.648A28.268,28.268,0,0,1,375.375,315",
    transform: "translate(189.621 -185.65)",
    fill: "#b0b0b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_757",
    "data-name": "Ret\\xE2ngulo 757",
    width: 22.135,
    height: 135.72,
    transform: "translate(216.234 44)",
    fill: "#b0b0b5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.695f1be2f36e618a90d92b2205539903.svg";
export { ForwardRef as ReactComponent };